// extracted by mini-css-extract-plugin
export default {"Detail":"Detail_Detail__cvd3R","Heading":"Detail_Heading__kIbyi","CompanyName":"Detail_CompanyName__mGz-t","Time":"Detail_Time__mB85y","Description":"Detail_Description__Jzs3Q"};